<div
  *ngIf="control"
  class="form-group"
  [class.required]="isRequired"
  [formGroup]="parentForm"
>
  <mat-form-field
    [floatLabel]="'always'"
    appearance="fill"
    [class.readonly]="readOnlyCss"
  >
    <mat-label>{{ title }}</mat-label>
    <input
      matInput
      appCapitalizeAllNoEvents
      appAsyncIbanValidator
      (change)="change()"
      mask="AAAA AAAA AAAA AAAA AAAA AAAA AAA"
      [validation]="false"
      placeholder="FR00 0000 0000 0000 0000 0000 000"
      [class.is-invalid]="control.invalid && control.touched"
      class="form-control"
      [formControlName]="formControlName"
    />

    <span
      class="success-mark"
      *ngIf="control.value && !control.errors && !control.pending"
    >
      <fa-icon [icon]="faCheck"></fa-icon>
    </span>
  </mat-form-field>

  <mat-error
    class="iban-error"
    *ngIf="
      control.touched &&
      (control.errors?.ibanValidator || control.errors?.required)
    "
  >
    <span>
      {{ 'BANK_DETAILS.ForeignIBAN' | labelText }}
    </span>
  </mat-error>
</div>
